import { render } from "./NumberRow.vue?vue&type=template&id=b9005884&scoped=true"
import script from "./NumberRow.vue?vue&type=script&lang=js"
export * from "./NumberRow.vue?vue&type=script&lang=js"

import "./NumberRow.vue?vue&type=style&index=0&id=b9005884&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9005884"]])

export default __exports__